import { LazyQueryHookOptions } from '@apollo/client';

import {
  ExternalIdentityVerificationAttributeFragment,
  ExternalIdentityVerificationAttributesQuery,
  ExternalIdentityVerificationAttributesQueryVariables,
  useExternalIdentityVerificationAttributesLazyQuery,
} from '@occc/graphql';

import { useLazyQuery } from '../utils';

const transformDataToArray = (
  data: ExternalIdentityVerificationAttributesQuery,
): ExternalIdentityVerificationAttributeFragment[] | null => {
  return data?.externalIdentityVerificationAttributes ?? null;
};

export const useGetExternalIdentityVerificationAttributesLazy = (
  baseOptions?: LazyQueryHookOptions<
    ExternalIdentityVerificationAttributesQuery,
    ExternalIdentityVerificationAttributesQueryVariables
  >,
) => {
  const [executeQuery, response] = useLazyQuery(
    useExternalIdentityVerificationAttributesLazyQuery,
    baseOptions,
  );

  return {
    executeQuery,
    response: {
      ...response,
      data: response.data ? transformDataToArray(response.data) : response.data,
    },
  };
};
